import React from 'react';
import UserList from './UserList';

const Admin = (props) => (
    <UserList {...props} />
);

export default Admin;
